import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_RISK_ZONE } from "../../../../common/constants/modules"
import { RiskZonesDetailSidebar } from "../../containers/RiskZonesDetailSidebar"
import { RiskZoneSelectListener } from "../../containers/RiskZoneSelectListener/RiskZoneSelectListener"
import { RiskZonesSidebar } from "../../containers/RiskZonesSidebar"

import { RiskZoneValidator } from "../RiskZoneValidator"

export const RiskZonesMobileRoutes = () => {
    const { getParams } = useUrlParams()
    const searchParams = getParams()

    const riskZonesRoutes = useRoutes([
        {
            path: "/*",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_RISK_ZONE} />
                <RiskZonesSidebar />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road/*",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad module={API_MODULE_RISK_ZONE} />
                <RiskZonesSidebar />
            </>,
        },
        {
            path: "/:road/:riskZoneId",
            element: <RiskZoneValidator>
                <RiskZoneSelectListener />
                <RiskZonesDetailSidebar />
            </RiskZoneValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return riskZonesRoutes
}